// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const extractError = (error: any) => {
  if (error.response && error.response.data) {
    return error.response.data.message;
  }
  return error.message;
};
